<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>营销策略</el-breadcrumb-item>
				<el-breadcrumb-item>邮件记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.planId" placeholder="请选择邮件计划" style="width:150px;">
					<el-option key="" label="请选择" value=""></el-option>
					<el-option v-for="item in planKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;&nbsp;
				<el-input v-model="query.resourceName" placeholder="公司" class="handle-input mr10" style="width:160px;"></el-input>
                <el-input v-model="query.mail" placeholder="接收邮箱" class="handle-input mr10" style="width:180px;"></el-input>
				<el-select v-model="query.status" placeholder="请选择发送状态" style="width:150px;">
					<el-option key="" label="请选择" value=""></el-option>
					<el-option key="0" label="待发送" value="0"></el-option>
					<el-option key="1" label="已发送" value="1"></el-option>
					<el-option key="2" label="发送成功" value="2"></el-option>
					<el-option key="3" label="发送失败" value="3"></el-option>
					<el-option key="4" label="无效" value="4"></el-option>
					<el-option key="5" label="已阅读" value="5"></el-option>
					<el-option key="6" label="进入官网" value="6"></el-option>
					<el-option key="7" label="查看产品" value="7"></el-option>
				</el-select>&nbsp;&nbsp;
				<el-date-picker 
						type="datetime"
						placeholder="发送开始时间"
						v-model="query.realSendTimeStart"
						value-format="yyyy-MM-dd HH:mm:SS"
						style="width:180px;"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="发送结束时间"
					v-model="query.realSendTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
					style="width:180px;"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				@cell-dblclick="handleShowResources"
				stripe
            >
				<el-table-column prop="planName" label="计划/模板">
					<template slot-scope="scope">
						{{scope.row.planName?scope.row.planName+" / " + scope.row.templateName:scope.row.templateName}}
					</template>
				</el-table-column>
                <el-table-column prop="resourceName" label="公司名称"></el-table-column>
				<el-table-column prop="mail" label="接收邮箱"></el-table-column>
				<el-table-column prop="sendTime" label="预计发送时间"></el-table-column>
				<el-table-column prop="realSendTime" label="实际发送时间"></el-table-column>
				<el-table-column prop="readTime" label="阅读时间"></el-table-column>
				<el-table-column prop="visitWebsiteTime" label="访问官网" width="90">
					<template slot-scope="scope">
						<el-tag :type = "scope.row.visitWebsiteTime?'success':'info'">{{scope.row.visitWebsiteTime?"是":"否"}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="visitProductTime" label="查看产品" width="90">
					<template slot-scope="scope">
						<el-tag :type = "scope.row.visitProductTime?'success':'info'">{{scope.row.visitProductTime?"是":"否"}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter = "statusFormater" width="90"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
						<el-button
                            type="text"
                            icon="el-icon-document-delete"
                            class="red"
                            @click="handleUnsubscribe(scope.$index, scope.row)"
							v-if="scope.row.status == 0 && controll['unsubscribe']"
                        >退订</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next, sizes"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
					:page-sizes="[10, 20, 50]"
                    @current-change="handlePageChange"
					@size-change="handleSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="viewVisible" width="60%">
            <el-descriptions class="margin-top" title="" :column="2" size="medium" border>
				<el-descriptions-item>
					<template slot="label">
						模板/计划
					</template>
					{{this.view.planName?this.view.planName+" / " + this.view.templateName:this.view.templateName}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						公司名称
					</template>
					{{this.view.resourceName}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						发送邮箱
					</template>
					{{this.view.sendMail}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						接收邮箱
					</template>
					{{this.view.mail}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						有效期
					</template>
					{{this.view.validTime}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						计划发送时间
					</template>
					{{this.view.sendTime}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						实际发送时间
					</template>
					{{this.view.realSendTime}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						状态
					</template>
					{{statusFormater(null, null, this.view.status)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						阅读邮件时间
					</template>
					{{this.view.readTime}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						访问官网时间
					</template>
					{{this.view.visitWebsiteTime}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						查看产品时间
					</template>
					{{this.view.visitProductTime}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						事件ID
					</template>
					{{this.view.eventId}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						请求ID
					</template>
					{{this.view.requestId}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						备注
					</template>
					{{this.view.remark}}
				</el-descriptions-item>
			 </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewVisible = false">取 消</el-button>
            </span>
        </el-dialog>
		<v-PotentialResourcesView ref="potentialResourcesView"></v-PotentialResourcesView>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchMarketingMailRecordData, saveMarketingMailRecord, deleteMarketingMailRecord, getMarketingMailRecord, 
getMarketingMailPlanKV, unsubscribe, getPotentialResources } from '../../../api/index';
import vPotentialResourcesView from '../../common/PotentialResourcesView.vue';
export default {
    name: 'market-mail-record',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            viewVisible: false,
            pageTotal: 0,
            view: {},
            idx: -1,
            id: -1,
			planKV:[],
			title:"",
			rules: {
                enumCode: [{ required: true, message:'请选择常量类型', trigger: 'blur' }],
                value: [{ required: true, message: '请输入常量值', trigger: 'blur' }]
            },
			exportIsShow:false,
			statusKV:{"0":"待发送","1":"已发送","2":"发送成功","3":"发送失败","4":"无效","5":"已阅读","6":"进入官网"},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("market-mail-record");
        this.getData();
		this.getPlans();
    },
	components: {
        vPotentialResourcesView
    },
    methods: {
		getPlans() {
			getMarketingMailPlanKV().then(res => {
				if (res.code == 0) {
					this.planKV = res.data;
				} else {
					this.$message.error("获取邮件计划失败！" + res.message);
				}
			});
		},
		statusFormater(row, column, cellValue) {
			return this.statusKV[cellValue];
		},
        // 获取记录数据
        getData() {
            fetchMarketingMailRecordData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		handleShow(index, row) {
			getMarketingMailRecord(row.id).then(res => { 
				if (res.code == 0 ) {
					this.view = res.data;
					this.viewVisible = true
				} else {
					this.$message.error("获取邮件记录失败！" + res.message);
				}
            });
		},
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailRecord([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		handleUnsubscribe(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除并取消订阅吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					unsubscribe([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('取消订阅成功');
							this.getData();
						} else {
							this.$message.error(`取消订阅失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailRecord(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleSizeChange(val) {
			this.$set(this.query, 'pageSize', val);
            this.getData();
		},
		handleShowResources(val) {
			if (this.controll['show-resources'] == undefined) {
				return;
			}
			if (val.resourcesId == undefined || val.resourcesId == "") {
				return;
			}
			getPotentialResources(val.resourcesId).then(res => {
				if (res.code == 0) {
					this.$nextTick(()=>{
						this.$refs.potentialResourcesView.setDatasource(res.data, this.platformKV);
					});
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
